import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import DaySelector from "../components/DaySelector";
import ScheduleTile from "../components/ScheduleTile";

const days = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday",
];

function WeekSchedule() {
  const [selectedDay, setSelectedDay] = useState(days[0]);
  const schedule = useSelector((state) =>
    state.auth?.user?.schedule.filter((sch) => sch.day === selectedDay)
  );

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="body-container">
      <h1 className="page-heading">Week's Schedule</h1>
      <DaySelector
        selectedDay={selectedDay}
        setSelectedDay={setSelectedDay}
        days={days}
      />
      {schedule?.length > 0 ? (
        schedule?.map((item) => (
          <ScheduleTile
            key={item._id}
            faculty_name={item.teacher[0]?.faculty_name}
            course_name={item.subject[0]?.course_name}
            cls={item.class}
            room={item.room}
            campus={item.campus}
            time={item.Time}
          />
        ))
      ) : (
        <div className="no-schedule">No class scheduled on {selectedDay}!</div>
      )}
    </div>
  );
}

export default WeekSchedule;
